/**
 * Central rules data re-export module.
 * Single import point for all MTG rules reference data.
 *
 * Usage:
 *   const { RULES_SECTIONS, KEYWORD_GLOSSARY, LAYERS, ... } = require('../helpers/rulesData');
 *
 * CommonJS module for compatibility with both backend (require) and
 * frontend (import via Webpack/Babel interop).
 *
 * @module rulesData
 */

const { SECTION_IDS, SECTION_ICONS, RULES_SECTIONS } = require('./rules/sectionsData');
const { KEYWORD_CATEGORIES, KEYWORD_THEMES, KEYWORD_GLOSSARY } = require('./rules/keywordData');
const { LAYER_NUMBERS, SUBLAYER_IDS, LAYERS } = require('./rules/layerData');
const { SBA_IDS, SBA_CATEGORIES, STATE_BASED_ACTIONS } = require('./rules/sbaData');
const { COMBAT_STEP_IDS, COMBAT_STEPS } = require('./rules/combatData');
const { STACK_SECTION_IDS, STACK_AND_PRIORITY } = require('./rules/stackData');
const { ZONE_IDS, ZONE_VISIBILITY, ZONES } = require('./rules/zonesData');

module.exports = {
  SECTION_IDS,
  SECTION_ICONS,
  RULES_SECTIONS,
  KEYWORD_CATEGORIES,
  KEYWORD_THEMES,
  KEYWORD_GLOSSARY,
  LAYER_NUMBERS,
  SUBLAYER_IDS,
  LAYERS,
  SBA_IDS,
  SBA_CATEGORIES,
  STATE_BASED_ACTIONS,
  COMBAT_STEP_IDS,
  COMBAT_STEPS,
  STACK_SECTION_IDS,
  STACK_AND_PRIORITY,
  ZONE_IDS,
  ZONE_VISIBILITY,
  ZONES,
};
